export const rules = {
  min_length: 1,
  min_CARD_length: 6,
  post_code_length: 4,

  min_phone: 6,
  max_phone: 30,
  max_url:200,

  businessinfo_in_org_type: 4, //REG, SOLE, PART, TRUST,CLUB, INST, GOV, OTH
  businessinfo_in_customer_name: 30,
  businessinfo_in_entity_name: 30,
  businessinfo_in_trust_name: 30,
  businessinfo_in_ABN: 11,
  businessinfo_in_NZBN: 13,
  businessinfo_in_ACN: 9,

  in_bank_contact: 30,
  in_bank_address1: 50,
  //where do we store this?
  in_bank_address2: 50,
  // is it supposed to be split out?
  in_bank_address3: 50,
  in_swift_address: 30,
  in_bank_account_name: 30,
  in_bsb: 30,
  in_account_number: 30,
  in_incorporation_place: 50,
  in_company_address_1: 50,
  in_company_address_2: 50,
  in_company_address_3: 50,
  in_company_street: 50,
  in_company_suburb: 50,
  in_company_country: 50,
  in_company_postcode: 10,
  in_parent_company: 50,
  in_delivery_address_1: 50,
  in_delivery_address_2: 50,
  in_delivery_address_3: 50,
  in_delivery_street: 50,
  in_delivery_suburb: 50,
  in_delivery_country: 50,
  in_delivery_postcode: 10,
  in_tenancy: 10, //OWN/LEASE
  in_time_at_address: 999,
  in_email: 100,
  in_phone: 15,
  in_fax: 200,
  in_required_credit: 4, //COD/10K/50K
  in_online_contact: 50,
  in_admin_email: 50,
  in_password: 50,
  in_part_ship: true,

  ///contact info
  in_manager_name: 30,
  in_manager_email: 50,
  in_manager_phone: 50,

  //Owner Info
  in_director1_name: 50,
  in_director1_dob: 14,
  in_director1_phone: 15,
  in_director1_address_1: 50,
  in_director1_address_2: 50,
  in_director1_address_3: 50,
  in_director1_street: 50,
  in_director1_suburb: 50,
  in_director1_country: 50,
  in_director1_postcode: 10,
  in_director1_licence_no: 20,

  //
  in_director2_name: 50,
  in_director2_dob: 11,
  in_director2_phone: 15,
  in_director2_address_1: 50,
  in_director2_address_2: 50,
  in_director2_address_3: 50,
  in_director2_street: 50,
  in_director2_suburb: 50,
  in_director2_country: 50,
  in_director2_postcode: 10,
  in_director2_licence_no: 20,

  //
  in_director3_name: 50,
  in_director3_dob: 11,
  in_director3_phone: 15,
  in_director3_address_1: 50,
  in_director3_address_2: 50,
  in_director3_address_3: 50,
  in_director3_street: 50,
  in_director3_suburb: 50,
  in_director3_country: 50,
  in_director3_postcode: 10,
  director_licence_no: 20,
  // //Trade References
  in_supplier1_name: 50,
  in_supplier1_contact: 50,
  in_supplier1_phone: 50,
  in_supplier1_email: 50,
  in_supplier2_name: 50,
  in_supplier2_contact: 50,
  in_supplier2_phone: 50,
  in_supplier2_email: 50,
  in_supplier3_name: 50,
  in_supplier3_contact: 50,
  in_supplier3_phone: 50,
  in_supplier3_email: 50,
  in_supplier4_name: 50,
  in_supplier4_contact: 50,
  in_supplier4_phone: 50,
  in_supplier4_email: 50,
  // //Financial Details
  // in_current_year_turnover                                          pic s9(11).9999
  // in_last_year_turnover                                                  pic s9(11).9999
  // in_current_assets                                                           pic s9(11).9999
  // in_current_liabilities                                                       pic s9(11).9999
  // in_capital                                                                             pic s9(11).9999
  // in_no_of_shares                                                             pic s9(11).9999
  // in_encumberance_charges                                         pic s9(11).9999
  // in_bankrupcy                                                                    pic x // Y/N
  // //Privacy
  // in_read_and_understood                                           pic x // Y/N
  // in_mailing_list                                                                   pic x // Y/N
  // in_mailing_email                                                              pic x
  // //Declaration
  in_declare_name: 50,
  in_declare_position: 50,
  in_declare_path: 100,
  // in_declare_date                                                               type date
  // //Guarantee
  in_guarantee_cust_name: 50,
  in_guarantor_name: 50,
  in_guarantor_address_1: 50,
  in_guarantor_address_2: 50,
  in_guarantor_address_3: 50,
  in_guarantor_street: 50,
  in_guarantor_suburb: 50,
  in_guarantor_country: 50,
  in_guarantor_postcode: 10,
  in_guarantor_sig_path: 100,
  // in_guarantor_date                                                          type date
  in_guarantor_abn: 11,
  in_guarantor_nzbn: 13,
  in_witness_name: 50,
  in_witness_address_1: 50,
  in_witness_address_2: 50,
  in_witness_address_3: 50,
  in_witness_street: 50,
  in_witness_suburb: 50,
  in_witness_country: 50,
  in_witness_postcode: 10,
  in_witness_sig_path: 100,
  // in_witness_date                                                              type date
  in_doc_path: 100
};



// WEBPACK FOOTER //
// ./src/app/model/lengthrule.ts